import { ETab } from "./app";

export const EXCEPTION_HEADERS_LIST : any = {
  [ETab.dashboard]: {
    "OSD-Module-Name": "dashboard",
  },
  [ETab.myAssignments]: {
    "OSD-Module-Name": "myAssignments",
  },
  [ETab.overages]: {
    "OSD-Module-Name": "overages",
  },
  [ETab.shortages]: {
    "OSD-Module-Name": "shortages",
  },
  [ETab.damages]: {
    "OSD-Module-Name": "damagesOrRefusals",
  },
  [ETab.onHandDelivery]: {
    "OSD-Module-Name": "onHand",
  },
  [ETab.misdelivery]: {
    "OSD-Module-Name": "misdelivery",
  },
  [ETab.cleared]: {
    "OSD-Module-Name": "dashboard",
  },
};
